import ourLogo from 'assets/images/logo.png'
import React from 'react'

import { Avatar, createStyles, Fade, Theme, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

const UserHeader: React.SFC<UserHeaderProps & WithStyles<typeof styles>> = ({
  classes,
  userFirstName,
  userLastName,
  userGroupName,
  userProfilePictureUrl = ourLogo,
}) => {
  return (
    <div className={classes.headerContainer}>
      <div className={classes.avatarContainer}>
        <Avatar key={userProfilePictureUrl} src={userProfilePictureUrl} className={classes.avatar} />
      </div>
      <Fade in={!!(userFirstName || userLastName || userGroupName)}>
        <div>
          <Typography variant="subtitle1" className={classes.userName}>
            {`${userFirstName} ${userLastName}`}
          </Typography>
          <Typography variant="body2" className={classes.userGroup}>
            {userGroupName}
          </Typography>
        </div>
      </Fade>
    </div>
  )
}

export type UserHeaderProps = {
  userFirstName?: string
  userLastName?: string
  userGroupName?: string
  userProfilePictureUrl?: string
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    headerContainer: {
      display: 'flex',
      padding: spacing(2),
      alignItems: 'center',
    },
    avatarContainer: {
      position: 'relative',
      height: spacing(8),
      // We need to set-up the min width. Otherwise, the width is not enforced.
      minWidth: spacing(8),
      width: spacing(8),
      marginRight: spacing(2),
    },
    avatar: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: spacing(8),
      width: spacing(8),
      backgroundColor: palette.primary.contrastText,
    },
    userName: {
      color: palette.primary.contrastText,
      fontWeight: 500,
      transition: 'all 0.5s',
    },
    userGroup: {
      marginTop: spacing(0.5),
      color: palette.primary.contrastText,
    },
  })

export default withStyles(styles)(UserHeader)
